export default {
  title: "Jogo do Brasil 29/06 - Copa do Mundo: Mudança no quadro de horários",
  resume: "Na tarde da segunda-feira (29/06), têm jogo do Brasil na Copa do Mundo. Confira as mudanças no quadro de horários das linhas.",
  img: "/news/soberania-brasil-gov-br.jpg",
  publishDate: "2026-06-28T00:00:00.000-03:00",
  content: [
    "As linhas metropolitanas operarão até as 12h no quadro de horários de dia útil atípico e, a partir, das 12h01, quadro de horário de sábados.",
    "<>Já as linhas municipais não obtivemos retorno quanto ao quadro de horários para o dia 29/06. Nesse caso, se você depende de linhas municipais, <Link to={\"/company/3\"}>entre em contato com a operadora</Link> ou com a Prefeitura da cidade.<>",
    "<>Para verificar os horários de sua linha de interesse, <Link to={\"/lines\"}>acesse a nossa página de consulta de horários</Link>.</>"
  ],
};
